import React from 'react';
import { Icon } from '../icons';
import { useT } from '../../i18n';

/**
 * Breadcrumbs — hierarchical path. The last item is treated as the current page.
 *
 * Props:
 *   items: Array<{ label, href?, onClick? }>
 *   separator: ReactNode  — default a chevron
 */
const Breadcrumbs = ({ items = [], separator, className = '' }) => {
  const t = useT();
  const sep = separator || <Icon.ChevronRight size={14} />;
  return (
    <nav className={`ps-breadcrumbs ${className}`.trim()} aria-label={t('Breadcrumb')}>
      <ol className="ps-breadcrumbs__list">
        {items.map((item, i) => {
          const last = i === items.length - 1;
          const interactive = !last && (item.href || item.onClick);
          return (
            <li key={i} className="ps-breadcrumbs__item">
              {interactive ? (
                <a
                  className="ps-breadcrumbs__link"
                  href={item.href || undefined}
                  onClick={item.onClick ? (e) => { if (!item.href) e.preventDefault(); item.onClick(e); } : undefined}
                >
                  {item.label}
                </a>
              ) : (
                <span className="ps-breadcrumbs__current" aria-current={last ? 'page' : undefined}>{item.label}</span>
              )}
              {!last && <span className="ps-breadcrumbs__sep" aria-hidden="true">{sep}</span>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
